import {Map} from "immutable";
import actions from './actions';

const init_state = new Map();


const Career = (state = init_state, action) => {
    switch (action.type) {
        case actions.SET_JOB_INFO: {
            return state.set('jobInfo',action.data);
        }
        case actions.SET_JOB_LIST: {
            return state.set('jobList',action.data);
        }
        default:
            return state;
    }
};

export default Career;